interface StepIngredient {
  recipeIngredientId: string;
  ingredientName: string;
  quantityText: string | null;
  unitText: string | null;
  rawText: string;
}

interface IngredientChipsProps {
  ingredients: StepIngredient[];
}

export function IngredientChips({ ingredients }: IngredientChipsProps) {
  if (ingredients.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1 mt-1.5">
      {ingredients.map((ing) => {
        const qty = ing.quantityText?.trim() ?? '';
        const unit = ing.unitText?.trim() ?? '';
        const amount = [qty, unit].filter(Boolean).join(' ');
        const name = ing.ingredientName?.trim() || ing.rawText;

        return (
          <span
            key={ing.recipeIngredientId}
            className="text-[11px] bg-gray-100 dark:bg-gray-700/50 text-gray-700 dark:text-gray-200 px-1.5 py-0.5 rounded-sm leading-tight"
            title={ing.rawText}
          >
            {name}
            {amount.length > 0 && (
              <>
                <span className="text-gray-400 dark:text-gray-500 mx-1">·</span>
                <span className="font-medium">{amount}</span>
              </>
            )}
          </span>
        );
      })}
    </div>
  );
}
